import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

export class LocalCache {
  public get(key: string): string {
    if (this.isExpired(key)) {
      this.clear(key);
    }
    return localStorage.getItem(key);
  }

  public set(key: string, value: any, timeout ?: number): void {
    localStorage.setItem(key, value);
    if (timeout) {
      const expiredAt = new Date();
      expiredAt.setSeconds(expiredAt.getSeconds() + timeout);
      localStorage.setItem(key + '_expire_at', expiredAt.toUTCString());
    }
  }

  protected isExpired(key: string): boolean {
    const expiredAtStr: string = localStorage.getItem(key + '_expire_at');
    if (expiredAtStr === null) {
      return false;
    }

    const expiredAt: Date = new Date(expiredAtStr);

    if ((new Date()) > expiredAt) {
      return true;
    }

    return false;
  }

  protected clear(key: string): void {
    localStorage.removeItem(key);
    localStorage.removeItem(key + '_expire_at');
  }

  public cachedObservable(key: string, obs: Observable<any>, timeout ?: number): Observable<any> {
    const cachedValue = this.get(key);
    if (cachedValue === null) {
      return obs
        .map((result: any) => {
          this.set(key, JSON.stringify(result), timeout);
          return result;
        });
    }

    return Observable.of(cachedValue).map(result => JSON.parse(result));
  }
}



// WEBPACK FOOTER //
// /app/src/app/utils/local-cache.utils.ts